import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=252c650c&scoped=true&"
import script from "@/views/Partners/Partners.ts?vue&type=script&lang=ts&"
export * from "@/views/Partners/Partners.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Partners/Partners.scss?vue&type=style&index=0&id=252c650c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c650c",
  null
  
)

export default component.exports